module.exports = __webpack_public_path__ + "static/media/flag.0f8cd44e.gif";